import React, { useEffect } from "react";
import DetailLayout from "../components/DetailLayout";
import style from "./index.module.scss";
import ExerciseStaticsButtons from "./components/ExerciseStaticsButtons";
import TopicList from "./components/TopicList";
import TopicDetail from "./components/TopicDetail";
import { RouteComponentProps } from "react-router-dom";
import CourseHeader from "../components/CourseHeader";
import { toNumber } from "service/service";
import {
    exerciseIdAtom,
    exerciseInfoAtom,
    selectedIdAtom,
    selectedIndexAtom,
    selectedQuestion,
    SortQuestionList,
    staticsAtom,
    useNavigateQuestion
} from "service/stores/Exercise/Statics";
import { useAtomValue, useSetAtom } from "jotai";
import { renderValidityTime } from "utils/common";
import { Button } from "antd";
import { useKeyPressEvent } from "react-use";
import WithProvider from "components/WithProvider";
import moment from "moment";
import ViewPublishLog from "../Exercise/components/ViewPublishLog";

interface ExerciseStaticsProps {
    exerciseId: string;
}

function ExerciseStatics({}: RouteComponentProps<ExerciseStaticsProps>) {
    const exerciseInfo = useAtomValue(exerciseInfoAtom);
    const selectedIndex = useAtomValue(selectedIndexAtom);
    const selectQuestion = useSetAtom(selectedIdAtom);
    const question = useAtomValue(selectedQuestion(selectedIndex));
    const { questionList, joinPercent } = useAtomValue(staticsAtom);
    const orderList = useAtomValue(SortQuestionList);
    const { goPrev, goNext } = useNavigateQuestion();

    useKeyPressEvent("ArrowLeft", goPrev);
    useKeyPressEvent("ArrowRight", goNext);

    // 上来选定第一题
    useEffect(() => {
        if (questionList.length === 0) return;
        selectQuestion(question.id);
    }, [questionList]);

    function usedTimeFormat() {
        return renderValidityTime(
            Math.ceil(toNumber(exerciseInfo.useTime) / 60)
        );
    }

    function timeFormat(time: string | null) {
        if (!time) return "";
        return moment(time).format("MM-DD HH:mm");
    }

    function renderInfo() {
        return (
            <div>
                <ViewPublishLog id={exerciseInfo.exerciseId} /> 活动时长{" "}
                {usedTimeFormat()} ｜ 开始时间{" "}
                {timeFormat(exerciseInfo.startTime)}&nbsp;
                {exerciseInfo.endTime && (
                    <span>结束时间 {timeFormat(exerciseInfo.endTime)}</span>
                )}
            </div>
        );
    }

    return (
        <DetailLayout breadcrumb="练习详情">
            <CourseHeader
                title={exerciseInfo.exerciseName}
                info={renderInfo()}
                extra={
                    <span className={style.percent}>参与率{joinPercent}</span>
                }
            />

            <ExerciseStaticsButtons />

            <div className={style.main}>
                <div className={style.left}>
                    <TopicList
                        selectedIndex={selectedIndex}
                        questionList={orderList}
                    />
                </div>

                <div className={style.right}>
                    <TopicDetail index={selectedIndex} data={question} />

                    <div className={style.footer}>
                        {selectedIndex !== 0 && (
                            <Button
                                type="link"
                                onClick={goPrev}
                                className={style.prev}>
                                上一题
                            </Button>
                        )}
                        {selectedIndex < questionList.length - 1 && (
                            <Button
                                type="link"
                                onClick={goNext}
                                className={style.next}>
                                下一题
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </DetailLayout>
    );
}

export default WithProvider(ExerciseStatics, ({ match }) => [
    [exerciseIdAtom, match.params.exerciseId]
]);
